import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import PitcherAttributesTable from '../components/PitcherAttributesTable';
import { API_ENDPOINTS } from '../config/api';

const PitcherAttributesPage = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ my: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Pitcher Attributes
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Comprehensive pitching attributes including velocity, movement, control, and pitch arsenal.
        </Typography>
        <PitcherAttributesTable apiUrl={API_ENDPOINTS.PITCHER_ATTRIBUTES_PAGINATED} />
      </Box>
    </Container>
  );
};

export default PitcherAttributesPage;
